import {
    DialogPositioningBehavior,
    DialogProps,
    DialogType,
    DialogWidget
  } from '@tableau/widgets';
  import React from 'react';

  import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
  import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSTestConnectionView } from '../components/KMSTestConnectionView';


export const openKMSTestConnectionDialog = (externalKeyId: string): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithoutTitleBar,
              testId: 'kms-key-test-connection-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width500px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, externalKeyId);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, externalKeyId: string) {
    return (
      <DialogWidget {...dialogProps}>
        {<KMSTestConnectionView closeDialog={closeAndDismiss} externalKeyId={externalKeyId} />}
      </DialogWidget>
    );
  }